import type { CoreUserDocument, CoreUserDocumentPayload } from '@flecto/types'

import { api } from '../../../services/api'

/**
 * Get document upload URL.
 *
 * @endpoint POST /api/me/document_upload
 * @scope shared
 * @see https://flecto.dev/api-5091115
 */
export async function getDocumentUploadUrl(
  document: CoreUserDocumentPayload
): Promise<CoreUserDocument> {
  const response = await api.post('/api/me/document_upload', document)

  return response.data as CoreUserDocument
}
